import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { AlertModalData, AlertsTabType } from '../reducer/alerts.reducer'
import { RootState } from '../store'
import { UserAlert, UserAlertLog } from '../proto/generated/nexus'
import { OrdersStateType } from '../reducer/orders.reducer'

const state = (state: RootState) => state


export const selectAlertsTab = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.alertsTab as AlertsTabType)
export const selectAlertModalData = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.alertModalData as AlertModalData)
export const selectAlertsLoading = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.loading as boolean)
export const selectAlertsLoaded = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.alertsLoaded as boolean)
export const selectUserAlerts = createDraftSafeSelector(state, (store: RootState) => store.alertsStore.alerts as UserAlert[])
const selectFiredAlertLogs = (s: RootState) => s.alertLogsStore.logs as UserAlertLog[]
const selectRecentFiredAlertIds = (s: RootState) => s.alertLogsStore.recentFiredAlerts as string[]
const selectRecentOrderFiredAlerts = (s: RootState) =>
    (s.ordersStore as OrdersStateType).recentFiredOrderAlerts

/** Recomputes only when alert logs or order-notification lists change — not on unrelated store updates (e.g. LTP ticks). */
export const selectFiredAlerts = createDraftSafeSelector(
    selectFiredAlertLogs,
    selectRecentOrderFiredAlerts,
    selectRecentFiredAlertIds,
    (firedAlerts, orderAlerts, recentFiredAlerts) => ({
        firedAlerts,
        orderAlerts,
        recentFiredAlerts,
    })
)